import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "observedInfo",
  data() {
    return {
      formData: {},
      saveIs: false,
      ip: localStorage.getItem("ip"),
      //端口和IP地址
      resu: 0,
      //用防止重复点击
      recId: this.$route.query.recId
    };
  },
  created() {
    this.load();
  },
  methods: {
    save() {
      this.saveIs = true;
      let determine = [];
      determine.push(this.formData.determine1, this.formData.determine2, this.formData.determine3, this.formData.determine4, this.formData.determine5, this.formData.determine6, this.formData.determine7, this.formData.determine8, this.formData.determine9, this.formData.determine10, this.formData.determine11, this.formData.determine12, this.formData.determine13, this.formData.determine14, this.formData.determine15, this.formData.determine16, this.formData.determine17, this.formData.determine18, this.formData.determine19, this.formData.determine20, this.formData.determine21, this.formData.determine22, this.formData.determine23, this.formData.determine24);
      let date = [];
      date.push(this.formData.data1, this.formData.data2, this.formData.data3, this.formData.data4, this.formData.data5, this.formData.data6, this.formData.data7, this.formData.data8, this.formData.data9, this.formData.data10, this.formData.data11, this.formData.data12, this.formData.data13, this.formData.data14, this.formData.data15, this.formData.data16, this.formData.data17, this.formData.data18, this.formData.data19, this.formData.data20, this.formData.data21, this.formData.data22, this.formData.data23, this.formData.data24, this.formData.data25, this.formData.data26, this.formData.data27, this.formData.data28, this.formData.data29, this.formData.data30, this.formData.data31, this.formData.data32, this.formData.data33, this.formData.data34, this.formData.data35, this.formData.data36, this.formData.data37, this.formData.data38, this.formData.data39);
      let result = [];
      result.push(this.formData.result1, this.formData.result2, this.formData.result3, this.formData.result4, this.formData.result5, this.formData.result6, this.formData.result7, this.formData.result8, this.formData.result9, this.formData.result10, this.formData.result11, this.formData.result12, this.formData.result13, this.formData.result14, this.formData.result15, this.formData.result16, this.formData.result17, this.formData.result18, this.formData.result19, this.formData.result20, this.formData.result21, this.formData.result22, this.formData.result23, this.formData.result24, this.formData.result25, this.formData.result26, this.formData.result27, this.formData.result28, this.formData.result29, this.formData.result30, this.formData.result31, this.formData.result32, this.formData.result33, this.formData.result34, this.formData.result35, this.formData.result36, this.formData.result37, this.formData.result38, this.formData.result39);
      let map = {
        "date": date.toString(),
        "result": result.toString(),
        "determine": determine.toString(),
        "observeId": this.formData.observeId,
        "createBy": sessionStorage.getItem("userName"),
        "recId": this.recId
      };
      request.post('/order/observe', map).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "录入成功",
            type: "success"
          });
          this.saveIs = false;
          this.$router.go(-1);
        } else {
          this.$message({
            message: "录入失败",
            type: "error"
          });
        }
      });
    },
    load() {
      this.formData = {};
      request.get('/order/observeShow', {
        params: {
          "recId": this.recId
          // "recId": 759
        }
      }).then(res => {
        if (res.code === "0") {
          if (res.data != null && res.data != '无数据') {
            this.formData = res.data;
          }
        } else {
          this.$message({
            message: "查询失败",
            type: "error"
          });
        }
      });
    },
    //返回上一页，即向前导航一步。
    back() {
      this.$router.go(-1);
    }
  }
};